import moment from 'moment'

const DISPLAY_FORMAT = 'DD-MMM-YY hh:mm A'

const TRIP_DATE_FORMATS = [
  moment.ISO_8601,
  'YYYY-MM-DDTHH:mm:ss',
  'YYYY-MM-DD HH:mm:ss',
  'YYYY-MM-DD',
  'DD-MMM-YY hh:mm A',
  'DD-MMM-YYYY hh:mm A',
]

const resolveTripDate = (date) => {
  if (date == null || date === '') return ''
  if (moment.isMoment(date) || date instanceof Date) return date
  if (typeof date === 'object') {
    return date.TripDate || date.ChartDate || date.TripDateTime || ''
  }
  return date
}

export const parseTripMoment = (date) => {
  const raw = resolveTripDate(date)
  if (!raw && raw !== 0) return moment.invalid()

  if (moment.isMoment(raw)) {
    return raw.clone()
  }

  if (raw instanceof Date) {
    return moment(raw)
  }

  const dateStr = String(raw).trim()
  if (!dateStr) return moment.invalid()

  return moment(dateStr, TRIP_DATE_FORMATS, true)
}

export const formatTripDateTime = (date) => {
  const raw = resolveTripDate(date)
  if (!raw && raw !== 0) return ''

  if (moment.isMoment(raw)) {
    return raw.isValid() ? raw.format(DISPLAY_FORMAT) : ''
  }

  if (raw instanceof Date) {
    const parsedDate = moment(raw)
    return parsedDate.isValid() ? parsedDate.format(DISPLAY_FORMAT) : ''
  }

  const dateStr = String(raw).trim()
  if (!dateStr) return ''

  const parsed = moment(dateStr, TRIP_DATE_FORMATS, true)
  if (parsed.isValid()) return parsed.format(DISPLAY_FORMAT)

  return dateStr === 'Invalid date' ? '' : dateStr
}

export const getTripSummary = (rows = []) => {
  const totalCapacity = rows.reduce(
    (sum, row) => sum + Number(row.TotalCapacity || 0),
    0
  );

  const utilizedCapacity = rows.reduce(
    (sum, row) => sum + Number(row.UtilizedWeight || 0),
    0
  );

  const availableCapacity = rows.reduce(
    (sum, row) => sum + Number(row.AvailableCapacity || 0),
    0
  );

  const utilization =
    totalCapacity > 0
      ? Number(((utilizedCapacity / totalCapacity) * 100).toFixed(2))
      : 0;
  const LRCount = rows.reduce(
    (sum, row) => sum + Number(row.LRCount || 0),
    0
  );
  const LRAmount = rows.reduce(
    (sum, row) => sum + Number(row.LRAmount || 0),
    0
  );
  return {
    totalCapacity,
    utilizedCapacity,
    availableCapacity,
    utilization,
    LRCount,
    LRAmount
  };
};